import React from 'react';
import { MdTune } from 'react-icons/md';
import { FiTrash2 } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import CommonMenu from './CommonMenu';

const CategoryOptionsMenu = ({ isOpen, onSelect, onClose }) => {
    const { t } = useTranslation();

    if (!isOpen) return null;

    const items = [
        {
            id: 'editCategory',
            label: t("categories.menu.edit"),
            icon: <MdTune size={20} />,
            onClick: () => {
                onSelect("editCategory");
                onClose();
            }
        },
        {
            id: 'deleteCategory',
            label: t("categories.menu.delete"),
            icon: <FiTrash2 size={20} />,
            className: "text-red-500",
            onClick: () => {
                onSelect("deleteCategory");
                onClose();
            }
        }
    ];

    return <CommonMenu onClose={onClose} items={items} />;
};

export default CategoryOptionsMenu; 